let testKeyring;
let loadedKeyring;
const resolveKeyring = async () => {
    if (testKeyring)
        return testKeyring;
    loadedKeyring ??= import('@napi-rs/keyring/keytar.js').then((module) => module);
    return loadedKeyring;
};
export const getKeyringPassword = async (service, account) => (await resolveKeyring()).getPassword(service, account);
export const setKeyringPassword = async (service, account, password) => (await resolveKeyring()).setPassword(service, account, password);
export const deleteKeyringPassword = async (service, account) => (await resolveKeyring()).deletePassword(service, account);
export const setKeyringForTests = (keyring) => {
    testKeyring = keyring;
};
//# sourceMappingURL=keyring.js.map